export default __webpack_public_path__ + "static/media/vehicle.66f21664364c9201b0fddf9ea05b1fb8.svg";